import {ReloadButton,} from '@flexinet/ui-components';
import {Box,} from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { accountsKeys } from '../hooks/useAccountsQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: accountsKeys.all });
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
